import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    id: "app",
    class: "app-safe-area"
};
import { onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useAuthStore } from "@/store/authStore";
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const router = useRouter();
        const route = useRoute();
        const auth = useAuthStore();
        onMounted(() => {
            const storedDark = localStorage.getItem("darkMode");
            document.documentElement.setAttribute("data-bs-theme", storedDark === "true" ? "dark" : "light");
            const lastRoute = localStorage.getItem("lastRoute");
            if (lastRoute && route.name === "login" && auth.isAuthenticated) {
                router.replace(lastRoute);
            }
        });
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_router_view)
            ]));
        };
    }
});
